'use client';

import { type FC } from 'react';
import { Dialog, Flex, Text, Input, ButtonGroup, Button } from '@/_components';
import type { DocumentNamingDialogProps } from './DocumentNamingDialog.types';

export const DocumentNamingDialog: FC<DocumentNamingDialogProps> = ({
  isOpen,
  currentFileIndex,
  totalFiles,
  currentFileName,
  originalFileName,
  isUploading,
  onFileNameChange,
  onSave,
  onCancel,
  onPreview,
}) => {
  const isLastDocument = currentFileIndex === totalFiles - 1;
  const buttonText = isLastDocument ? 'Save' : 'Next';

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title="Name your document"
      isNarrow
    >
      <Flex isColumn gap={4} style={{ padding: '24px' }}>
        <Text type="small" color="secondary">
          Document {currentFileIndex + 1} of {totalFiles} (
          <a className="underline" onClick={onPreview}>
            {originalFileName}
          </a>
          )
        </Text>
        <Input
          label="Document name"
          placeholder="Enter document name"
          type="text"
          value={currentFileName}
          onChange={(e) => onFileNameChange(e.target.value)}
          autoFocus
        />
        <ButtonGroup align="right">
          <Button
            intent="secondary"
            onClick={onCancel}
            size="small"
            type="button"
            value="Cancel"
            isDisabled={isUploading}
          />
          <Button
            intent="primary"
            onClick={onSave}
            size="small"
            type="button"
            value={buttonText}
            isDisabled={!currentFileName.trim() || isUploading}
            isLoading={isUploading}
          />
        </ButtonGroup>
      </Flex>
    </Dialog>
  );
};
